import { API_ENDPOINTS, ORDER_ENQUIRY } from "../constants/apiConfig";
import { makeRequest } from "../middleware/axiosMiddleware"

export const orderEnquiryService = {
    getEnquiriesList,
    getEnquiryStatus,
    getLimitedEnquiriesList,
    getFSEList,
    getArchivedData,
    getArchivedDataDetails,
    getFSEEnquiriesList,
    getLimitedFSEEnquiriesList,
};

async function getEnquiriesList(customerTierType: any, filterParams: any, isMyEnquiryChecked?: any, isAnnexureCorePartChecked?: any, page?: any,) {
    const userApiPath = API_ENDPOINTS.ENQUIRY + ORDER_ENQUIRY.API_PATH + `/customers/${sessionStorage.getItem('customerId')}`;
    const SREApiPath = API_ENDPOINTS.ENQUIRY + ORDER_ENQUIRY.API_PATH + `/SRE/${sessionStorage.getItem('webApplicationLoginId')}`;
    const apiPath = sessionStorage.getItem('userType') === "sre" ? SREApiPath : userApiPath
    const type = sessionStorage.getItem('userType') === "sre" ? customerTierType === 'TPC Dealer' ? 'tpcdealer' : customerTierType : customerTierType?.trim()
        ? customerTierType.toLowerCase()
        : customerTierType.toLowerCase();
    const options = {
        path: `${apiPath}`,
        method: "POST",
        bodyObj: {
            "sessionDetails": {
                "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
                "clientIPAddress": sessionStorage.getItem('clientIp'),
            },
            "searchParams": filterParams,
            customerType: type,
            b2cUserId: sessionStorage.getItem('userType') === "sre" ? '' : isMyEnquiryChecked === true ? sessionStorage.getItem('userId') : "",
            isAnnexureEnquiry: isAnnexureCorePartChecked,
            userRole: sessionStorage.getItem('userType') === "sre" ? 'SRE' : ''
        },
        customHeaders: {
            "Lob-Id": "AUTO",
            "Channel-Id": "B2B",
            "Paging-Info": `start-index=${page ? (parseInt(page) * 10) : 0}|no-of-records=10`
        },
        formdata: true
    };
    return await makeRequest(options)
}

async function getArchivedData(data: any, page?: any,) {
    const apiPath = API_ENDPOINTS.ENQUIRY + ORDER_ENQUIRY.API_PATH;
    const options = {
        path: `${apiPath}/orders/archivedData`,
        method: "POST",
        bodyObj: data,
        customHeaders: {
            "Lob-Id": "AUTO",
            "Channel-Id": "B2B",
            "Paging-Info": `start-index=${page ? (parseInt(page) * 10) : 0}|no-of-records=10`
        },
        formdata: true
    };
    return await makeRequest(options)
}

async function getArchivedDataDetails(data: any) {
    const apiPath = API_ENDPOINTS.ENQUIRY + ORDER_ENQUIRY.API_PATH;
    const options = {
        path: `${apiPath}/orders/archivedDataOrderDetails`,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}



async function getFSEEnquiriesList(customerTypeAccess: any, filterParams: any, isAnnexureEnquiry?: any, page?: any,) {
    const FSEApiPath = API_ENDPOINTS.ENQUIRY + ORDER_ENQUIRY.API_PATH + `/FSE/${sessionStorage.getItem('webApplicationLoginId')}`;
    const SREApiPath = API_ENDPOINTS.ENQUIRY + ORDER_ENQUIRY.API_PATH + `/SRE/${sessionStorage.getItem('webApplicationLoginId')}`;
    const apiPath = sessionStorage.getItem('userType') === "sre" ? SREApiPath : FSEApiPath

    const options = {
        path: `${apiPath}`,
        method: "POST",
        bodyObj: {
            "sessionDetails": {
                "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
                "clientIPAddress": sessionStorage.getItem('clientIp'),
            },
            "searchParams": filterParams,
            "FseCustomerType": customerTypeAccess,
            "userRole": sessionStorage.getItem('userType') === "sre" ? 'SRE' : "FSE",
            "isAnnexureEnquiry": isAnnexureEnquiry
        },
        customHeaders: {
            "Lob-Id": "AUTO",
            "Channel-Id": "B2B",
            "Paging-Info": `start-index=${page ? (parseInt(page) * 10) : 0}|no-of-records=10`
        },
        formdata: true
    };
    return await makeRequest(options)
}

async function getLimitedFSEEnquiriesList(customerTypeAccess: any, filterParams: any, page?: any,) {
    const apiPath = API_ENDPOINTS.ENQUIRY + ORDER_ENQUIRY.API_PATH;
    const options = {
        path: `${apiPath}/FSE/${sessionStorage.getItem('webApplicationLoginId')}`,
        method: "POST",
        bodyObj: {
            "sessionDetails": {
                "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
                "clientIPAddress": sessionStorage.getItem('clientIp'),
            },
            "searchParams": filterParams,
            "FseCustomerType": customerTypeAccess,
            "userRole": "FSE"
        },
        customHeaders: {
            "Lob-Id": "AUTO",
            "Channel-Id": "B2B",
            "Paging-Info": `start-index=${page ? (parseInt(page) * 5) : 0}|no-of-records=5`
        },
        formdata: true
    };
    return await makeRequest(options)
}


async function getLimitedEnquiriesList(customerTierType: any, filterParams: any, page?: any) {
    const apiPath = API_ENDPOINTS.ENQUIRY + ORDER_ENQUIRY.API_PATH;
    const type = customerTierType && customerTierType.toLowerCase();
    const options = {
        path: `${apiPath}/customers/${sessionStorage.getItem('customerId')}`,
        method: "POST",
        bodyObj: {
            "sessionDetails": {
                "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
                "clientIPAddress": sessionStorage.getItem('clientIp'),
            },
            "searchParams": filterParams,
            customerType: type,
        },
        customHeaders: {
            "Lob-Id": "AUTO",
            "Channel-Id": "B2B",
            "Paging-Info": `start-index=${page ? (parseInt(page) * 5) : 0}|no-of-records=5`
        },
        formdata: true
    };
    return await makeRequest(options)
}

async function getEnquiryStatus(customerTierType: any) {
    const type = customerTierType && customerTierType.toLowerCase();
    const apiPath = API_ENDPOINTS.DEALER_ENDPOINT + ORDER_ENQUIRY.FORMFIELD + `/enquiryStatus?customerType=${type}`;
    const options = {
        path: apiPath,
        method: "GET",
        formdata: true
    };
    return await makeRequest(options)
}

async function getFSEList() {
    const apiPath = API_ENDPOINTS.DEALER_ENDPOINT + `/formField/masterData?dataType=fseUserListForFsePortal&loginId=${sessionStorage.getItem('webApplicationLoginId')}`
    const options = {
        path: apiPath,
        method: "GET",
        formdata: true
    };
    return await makeRequest(options)
}

